export interface iAddUpdateRequestBody {
  email: string;
  firstName: string;
  isUpdateUser: boolean;
  lastName: boolean;
  titleCode: string;
  userType: string;
}
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  FormControl,
  FormGroup, Validators
} from '@angular/forms';
import { OccEndpointsService } from '@spartacus/core';
import { CustomFormValidators } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UserManagementService {
  constructor(private userAccount: UserAccountFacade, private httpClient: HttpClient, private occService: OccEndpointsService) { }

  user: FormGroup = new FormGroup({
    salutation: new FormControl('', [Validators.required]),
    first_name: new FormControl('', [Validators.required, CustomFormValidators.noSpecialCharacters]),
    last_name: new FormControl('', [Validators.required, CustomFormValidators.noSpecialCharacters]),
    email: new FormControl('', [Validators.required, CustomFormValidators.emailValidator]),
    role: new FormControl('', Validators.required)
  });



  getUserList(): Observable<any> {
    return this.userAccount
      .get()
      .pipe(
        mergeMap((user: any) => user !== undefined ?
          this.httpClient.get<any>(
            this.occService.buildUrl(
              `/orgUsers/${user?.uid}/b2bUserLists/${user?.orgUnit?.uid}?currentPage=0&fields=DEFAULT&pageSize=300&sort=name`
            )
          ) : of({})
        ));
  }

  getUserDetails(userId: string) {
    return this.userAccount
      .get()
      .pipe(
        mergeMap((user: any) => user !== undefined ?
          this.httpClient.get<any>(
            this.occService.buildUrl(
              `/orgUsers/${user?.uid}/b2bUserDetails/${userId}`
            )
          ) : of({})
        ));
  }

  addOrUpdateUser(request: any) {

    return this.userAccount
      .get()
      .pipe(
        mergeMap((user: any) =>
          this.httpClient.post<any>(
            this.occService.buildUrl(
              `/orgUsers/${user?.uid}/createUpdateB2BUser?fields=DEFAULT`
            )
            , request
          )
        ));
  }
}
